// extracted by mini-css-extract-plugin
export default {"root":"style_root__25g2y","input":"style_input__+Os6r","label":"style_label__RuuPt"};